import { graphql } from 'services/api';
import { REMOVE_PAGE } from 'graphqlQueriesAndMutations/mutations';

export async function deleteShowCase(idToDelete: string, handleNotify: any) {
	const resp = { isSuccess: false };
	try {
		await graphql.mutate({
			mutation: REMOVE_PAGE,
			variables: {
				id: idToDelete
			}
		});
		resp.isSuccess = true;
		handleNotify('Vitrine dinâmica deletada com sucesso', 'success');
	} catch (error: any) {
		resp.isSuccess = false;
		handleNotify(
			error?.message || 'Erro ao deletar a vitrine dinâmica',
			'error'
		);
	}

	return resp;
}
